module.exports = __webpack_public_path__ + "static/media/sucess.c9073929.svg";